var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#bd';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-bd';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 50 9',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };